import React from 'react'
import { mergeProps } from 'src/util'
import styles from './InputGroup.scss'

const InputGroup = props => <div {...mergeProps()({ className: styles.group }, props)} />

export default InputGroup
